const BREAKPOINT_SIZES = {
  s: 640,
  m: 768,
  l: 1024,
  xl: 1280,
  xxl: 1536,
} as const;

const minWidth = {
  s: `(min-width: ${BREAKPOINT_SIZES.s}px)`,
  m: `(min-width: ${BREAKPOINT_SIZES.m}px)`,
  l: `(min-width: ${BREAKPOINT_SIZES.l}px)`,
  xl: `(min-width: ${BREAKPOINT_SIZES.xl}px)`,
  xxl: `(min-width: ${BREAKPOINT_SIZES.xxl}px)`,
} as const;

const maxWidth = {
  s: `(max-width: ${BREAKPOINT_SIZES.s - 1}px)`,
  m: `(max-width: ${BREAKPOINT_SIZES.m - 1}px)`,
  l: `(max-width: ${BREAKPOINT_SIZES.l - 1}px)`,
  xl: `(max-width: ${BREAKPOINT_SIZES.xl - 1}px)`,
  xxl: `(max-width: ${BREAKPOINT_SIZES.xxl - 1}px)`,
} as const;

interface GetMediaConfig {
  minWidth?: keyof typeof minWidth;
  maxWidth?: keyof typeof maxWidth;
}

/**
 * returns a single mediaquery rule.
 *
 * example: `breakpoint.minWidth.s` returns `(min-width: 640px)`.
 */
const breakpoint = { minWidth, maxWidth };

/**
 * returns a mediaquery ruleset based on its configuration.
 *
 * example: `getMedia({ minWidth: 's', maxWidth: 'm' })` returns `(min-width: 640px) and (max-width: 767px)`.
 *
 * @param config - each item in config represents a query that gets stringed together
 */
function getMedia(config: GetMediaConfig): string {
  return Object.entries(config).reduce((acc, [key, value]) => {
    const query = breakpoint[key] && breakpoint[key][value];
    if (!query) {
      return acc;
    }
    return `${acc && `${acc} and `}${query}`;
  }, '');
}

export { BREAKPOINT_SIZES, breakpoint, getMedia };
